export default __webpack_public_path__ + "static/media/register-background.49b1fc2f.png";